import { connect, MapStateToProps } from 'react-redux';
import { Props } from './ProfileHeroMobile';
import { AppState } from '../../../../types/store';
import { getCoverDeviation } from '../../../selectors/deviations';
import {
  getProfileOwnerUser,
  getProfileOwnerStats,
  getProfileOwnerTagline,
  getIsGroupProfile,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';

export type StateProps = Pick<
  Props,
  | 'coverDeviation'
  | 'profileOwnerUser'
  | 'isOwner'
  | 'isGroup'
  | 'tagline'
  | 'stats'
>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const coverDeviation = getCoverDeviation(state);
  const profileOwnerUser = getProfileOwnerUser(state);
  const tagline = getProfileOwnerTagline(state);
  const stats = getProfileOwnerStats(state);
  const isOwner = isCurrentUserProfileOwner(state);
  const isGroup = getIsGroupProfile(state);
  return {
    stats,
    isOwner,
    isGroup,
    tagline,
    coverDeviation,
    profileOwnerUser,
  };
};

export default connect(mapStateToProps);
